import { IBoondock, IBoondockRating } from '../interfaces';
import { Rating } from './rating';
import { User } from './user';

export class BoondockRating extends Rating implements IBoondockRating {
  rated?: IBoondock;
  ratedId?: number;
  scheduleCode?: string;

  constructor(data?: IBoondockRating) {
    super(data);

    if (data) {
      this.setData(data);
    }
  }

  setData(data: IBoondockRating): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }

    if (this.creator) {
      this.creator = new User(this.creator);
    }
  }
}
